<template>
  <ion-button :aria-label="$t('config.title')" @click="openConfig">
    <ion-icon slot="icon-only" :icon="icons.settingsOutline"></ion-icon>
  </ion-button>
</template>

<script>
import { IonButton, IonIcon, modalController } from '@ionic/vue';
import { settingsOutline } from 'ionicons/icons';

import ODNModalConfig from '@m/odn-modal-config.vue';

// Reusable toolbar button that opens the app configuration modal. Drop it inside
// an <ion-buttons slot="end"> of any page/modal toolbar that hosts a photo field.
export default {
  name: 'ODNConfigButton',
  components: {
    IonButton,
    IonIcon,
  },
  data() {
    return {
      icons: {
        settingsOutline,
      },
    };
  },
  methods: {
    async openConfig() {
      const modal = await modalController.create({
        component: ODNModalConfig,
      });
      await modal.present();
    },
  },
};
</script>
